

































import { Component, Vue } from "vue-property-decorator"
import Event from "./Event.vue"
import { Howl } from "howler"

@Component({
  components: {
    Event
  }
})
export default class EventsMenu extends Vue {
  // Decorators: https://github.com/kaorun343/vue-property-decorator
  // Class: https://github.com/vuejs/vue-class-component
  get event() {
    if (!this.$store.state.muted) {
      new Howl({
        src: ["/audio/Notification.mp3"]
      }).play()
    }
    return this.$store.getters.event
  }
}
